module.exports = __webpack_public_path__ + "public/Icons/linkedin.png?64b00e81";